import { z } from 'zod'

export type NoSpendersListFormValues = z.infer<typeof NoSpendersListFormSchema>

export const NoSpendersListFormSchema = z.object({
  name: z
    .string()
    .min(1, { message: 'List name is required' })
    .refine((val) => val.trim().length > 0, {
      message: 'List name is required',
    }),
  minimumDays: z.coerce.number().int('Please enter a valid number').min(1, {
    message: 'Minimum 1 day for custom no spenders list',
  }),
})
